import React, {useMemo} from "react";
import ChoiceMenu from "@gotombola/react-ds/lib/molecules/ChoiceMenu";
import useGameBuyBookPayments from "../../../hooks/useGameBuyBookPayments";
import useTypeTranslation from "@gotombola/react-ds/lib/hooks/useTypeTranslation";
import Spinner from "@gotombola/react-ds/lib/atoms/Spinner";
import GameBookPaymentBlockedPanel from "../../buy/molecules/GameBookPaymentBlockedPanel";

export function PaymentBuyBookGameForm({ game, book, prepayment, workflows }: PaymentBuyBookGameFormProps) {
    const {t} = useTypeTranslation('game', game);

    const [items, { blockMode }] = useGameBuyBookPayments(book, game, { t, workflows, prepayment });

    const customSingleItemLabel = useMemo(() => game?.paymentSingleItemButtonLabel, [game?.paymentSingleItemButtonLabel]);

    return (
      <>
          {!blockMode && <ChoiceMenu items={items} customSingleItemLabel={customSingleItemLabel} />}
          {!blockMode && !items.length && <Spinner />}
          {blockMode && <GameBookPaymentBlockedPanel game={game} />}
      </>
    );
}

export interface PaymentBuyBookGameFormProps {
    game: any;
    book: any;
    prepayment: any;
    workflows: any;
}

export default PaymentBuyBookGameForm;
